<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <div>
          <b-table responsive bordered striped hover :items="list" :fields="fields">

          </b-table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
    import Resource from '@/api/resource';

    const areaResource = new Resource('areas');
    export default {
        name: "ListAreas",
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen',
                        sortable: false,
                        thStyle: {
                            width: '200px'
                        }
                    }
                ],
                list: null,
                total: 0,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 15,
                },
            }
        },
        created() {
            this.getList();
        },
        methods: {
            async getList() {
                this.listLoading = true;
                const {data} = await areaResource.list(this.listQuery);
                this.list = data;
                this.total = data.length;
                this.listLoading = false;
            }
        }
    }
</script>

<style scoped>

</style>
